/** Cada extra Wasabi y Jengibre incluye 2 piezas por 1 euro. */
export const WASABI_GINGER_PIECES = 2;

export const WASABI_GINGER_OPTIONS = [
  {
    id: 133,
    name: 'Wasabi',
    product_name: 'WASABI',
    xetux_product_id: 133,
    xetux_item_id: 133,
  },
  {
    id: 134,
    name: 'Jengibre',
    product_name: 'JENGIBRE',
    xetux_product_id: 134,
    xetux_item_id: 134,
  },
];

function normalizeExtraName(name) {
  return String(name || '')
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function isWasabiGingerExtra(name) {
  const normalized = normalizeExtraName(name);
  return (
    normalized.includes('WASABI') &&
    (normalized.includes('JENGIBRE') || normalized.includes('GENGIBRE'))
  );
}

export function emptyWasabiGingerQty() {
  return Object.fromEntries(WASABI_GINGER_OPTIONS.map((option) => [option.id, 0]));
}

export function wasabiGingerTotal(quantities) {
  return WASABI_GINGER_OPTIONS.reduce(
    (sum, option) => sum + (Number(quantities?.[option.id]) || 0),
    0
  );
}

export function wasabiGingerSelection(quantities) {
  return WASABI_GINGER_OPTIONS.map((option) => ({
    ...option,
    quantity: Number(quantities?.[option.id]) || 0,
  })).filter((option) => option.quantity > 0);
}

export function formatWasabiGingerSummary(rows) {
  return (Array.isArray(rows) ? rows : [])
    .filter((row) => Number(row?.quantity) > 0)
    .map((row) => `${row.name || row.product_name} x${row.quantity}`)
    .join(', ');
}
